import { Navigate, Outlet, useLocation } from 'react-router';

import { ErrorMessage } from '../components/ErrorMessage';
import { FullPageLoader } from '../components/Loader';
import { useAuth } from './context';
import { NoticeGate } from './NoticeGate';
import { PasswordGate } from './PasswordGate';

export function RequireAuth() {
  const { status, error, retry, me } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageLoader label="Anmeldung wird geprüft …" />;
  if (status === 'error') {
    return (
      <div className="center-page">
        <ErrorMessage error={error} onRetry={retry} />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return (
    <>
      <Outlet />
      {me?.must_change_password ? <PasswordGate /> : me?.pending_notice && <NoticeGate notice={me.pending_notice} />}
    </>
  );
}
